import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { TabGroup } from "@headlessui/react-v2";
import { isFunction, noop } from "lodash";
import type { ReactNode } from "react";

interface GroupProps {
  children: ReactNode;
  className?: string;
  id?: string;
  onChange?: (index: number) => void;
  selectedIndex?: number;
}

export const Group = ({ children, className = "", ...props }: GroupProps) => (
  <TabGroup
    as="div"
    data-testid="tab-group"
    selectedIndex={props.selectedIndex}
    onChange={
      isFunction(props.onChange)
        ? (index: number) => {
            props.onChange?.(index);
          }
        : noop
    }
    className={classNames("text-dark size-full overflow-auto", className)}
    {...props}
  >
    {children}
  </TabGroup>
);

Group.displayName = "Tab.Group";
